__turbopack_context__.v({
  "accoCard": "XOWnLW_accoCard",
  "amountOfPeople": "XOWnLW_amountOfPeople",
  "breadcrumbs": "XOWnLW_breadcrumbs",
  "cardHeader": "XOWnLW_cardHeader",
  "cardMain": "XOWnLW_cardMain",
  "footer": "XOWnLW_footer",
  "footerDetails": "XOWnLW_footerDetails",
  "iconButton": "XOWnLW_iconButton" + " " + __turbopack_context__.i(248112)["focusOutline"],
  "imageContainer": "XOWnLW_imageContainer",
  "mealplans": "XOWnLW_mealplans",
  "overlayLink": "XOWnLW_overlayLink" + " " + __turbopack_context__.i(248112)["focusOutline"],
  "overview": "XOWnLW_overview",
  "priceBoxWrapper": "XOWnLW_priceBoxWrapper",
  "rating": "XOWnLW_rating",
  "ratingContainer": "XOWnLW_ratingContainer",
  "secondaryText": "XOWnLW_secondaryText",
  "titleContainer": "XOWnLW_titleContainer",
  "tripDates": "XOWnLW_tripDates",
  "usp": "XOWnLW_usp",
  "uspIcon": "XOWnLW_uspIcon",
  "uspsWrapper": "XOWnLW_uspsWrapper",
});
